@if (loading()) {
  <div class="app-loader">
    <div class="app-loader__spinner"></div>
  </div>
} @else {
  <router-outlet />
}
